import { render, staticRenderFns } from "./SelectTipoProduto.vue?vue&type=template&id=c6e991da&scoped=true"
import script from "./SelectTipoProduto.vue?vue&type=script&lang=ts"
export * from "./SelectTipoProduto.vue?vue&type=script&lang=ts"
import style0 from "./SelectTipoProduto.vue?vue&type=style&index=0&id=c6e991da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e991da",
  null
  
)

export default component.exports